/* eslint-disable camelcase */
type Locale = 'en' | 'es';

type Phrase = (l: Locale) => string;

export const i18n_why_yoga_international: Phrase = locale => {
  const en = `Why Yoga International?`;
  const phrases: { [key: string]: undefined | string } = {
    en,
    es: `¿Por Que Yoga International?`,
  };
  return phrases[locale] || en;
};
